module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_straight_vector.5c6d1671.svg";